// Fishelper theme — minimal progressive enhancement.
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-gallery]');
    const main = gallery.querySelector('[data-gallery-main]');
    main.src = thumb.dataset.full;
    main.alt = thumb.dataset.alt || main.alt;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }

  const step = e.target.closest('[data-qty-step]');
  if (step) {
    e.preventDefault();
    const input = step.parentElement.querySelector('input[name="quantity"]');
    const next = Math.max(1, parseInt(input.value || '1', 10) + parseInt(step.dataset.qtyStep, 10));
    input.value = next;
  }
});

// Variant selector -> update hidden id + price
document.addEventListener('change', (e) => {
  const select = e.target.closest('[data-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  const option = select.selectedOptions[0];
  form.querySelector('input[name="id"]').value = select.value;
  const priceEl = document.querySelector('[data-product-price]');
  if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
});
